import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import grupoVipImage from '~/assets/grupo-vip.jpeg';

const VIP_GROUP_DISMISS_KEY = 'vip-group-dismissed';
const ONE_HOUR_MS = 60 * 60 * 1000; // 1 hora em milissegundos

const FloatingVipButton: React.FC = () => {
  const { pathname } = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [shouldShow, setShouldShow] = useState(true);

  // Verificar se deve mostrar o botão (após 1h do fechamento)
  useEffect(() => {
    const dismissedAt = localStorage.getItem(VIP_GROUP_DISMISS_KEY);
    if (dismissedAt) {
      const dismissedTime = parseInt(dismissedAt, 10);
      const now = Date.now();
      const timeSinceDismissed = now - dismissedTime;
      
      // Só mostra novamente se já passou 1 hora
      if (timeSinceDismissed < ONE_HOUR_MS) {
        setShouldShow(false);
      }
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(VIP_GROUP_DISMISS_KEY, Date.now().toString());
    setShouldShow(false);
    setIsVisible(false);
  };

  const pathSegments = pathname.split('/').filter(Boolean);
  const isHomePage = pathSegments.length === 1;
  const isAboutPage = pathSegments.length === 2 && pathSegments[1] === 'about';

  if (!isHomePage && !isAboutPage) return null;
  if (!isVisible || !shouldShow) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 80,
        left: 20,
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        gap: 12,
      }}
    >
      <button
        onClick={handleClose}
        style={{
          position: 'absolute',
          top: -10,
          right: -10,
          width: 24,
          height: 24,
          borderRadius: '50%',
          background: '#ff4444',
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
          fontSize: 14,
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
          zIndex: 10000,
          padding: 0,
          lineHeight: 1,
        }}
        title="Fechar"
      >
        ×
      </button>
      <a
        href="https://chat.whatsapp.com/InwdVyEiLm2DdkStJFqBq0?mode=gi_t"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          width: 70,
          height: 70,
          borderRadius: '50%',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          transition: 'transform 0.3s ease',
          flexShrink: 0,
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        <img
          src={grupoVipImage}
          alt="Grupo VIP Fatia Prime"
          style={{
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            objectFit: 'cover',
          }}
        />
      </a>
      <a
        href="https://chat.whatsapp.com/InwdVyEiLm2DdkStJFqBq0?mode=gi_t"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
          color: '#1a1a1a',
          padding: '10px 16px',
          borderRadius: '20px',
          fontSize: 13,
          fontWeight: 600,
          textDecoration: 'none',
          boxShadow: '0 4px 12px rgba(255, 165, 0, 0.4)',
          lineHeight: 1.4,
          maxWidth: 220,
          minWidth: 190,
          whiteSpace: 'nowrap',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'translateX(4px)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(255, 165, 0, 0.5)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'translateX(0)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 165, 0, 0.4)';
        }}
      >
        <span style={{ display: 'block' }}>✨ Entre no Grupo VIP</span>
        <span style={{ display: 'block', fontSize: 11, fontWeight: 500, opacity: 0.9 }}>
          Ofertas exclusivas & novidades!
        </span>
      </a>
    </div>
  );
};

export default FloatingVipButton;
